import api from './api';

export const getAllCentroCusto = () => api.get('centroCusto');
export const getAllCentroCustoByCodigo = (codigo: string) => api.get(`centroCusto/${codigo}`);
export const getAllCentroCustoOptions = () =>
  getAllCentroCusto().then(cc => (cc || []).map(item => ({ text: item.codigo, value: item.codigo })));
